import React, { FC, useContext, useState } from "react";

import { BoardContext, TeamContext, UserContext } from "../../../../../context";
import { Phase } from "../../../../../util/enums";
import { ICard } from "../../../../../interfaces";

import { useWindowDimensions } from "../../../../../hooks";
import { InfoButton } from "../../..";

interface StrengthCardProps {
    cardData: ICard;
    isFullScreenOn?: boolean;
    strengthCardIndex?: number;
}

const StrengthCard: FC<StrengthCardProps> = ({cardData, isFullScreenOn, strengthCardIndex}) => {
    const { game, teamNumber } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const { instructionTutorial } = useContext(BoardContext);
    const { width } = useWindowDimensions();
    const [displayInfo, setDisplayInfo] = useState<boolean>(false);
    const pathname : string | undefined = window.location.pathname;
    const isPageSlotMachineDemoRendered : boolean = pathname.includes("/slotmachineDemo");
    const isBrowserWidthNecessary : boolean = (teamNumber && userData && game?.phase === Phase.SLOT_MACHINE) || isPageSlotMachineDemoRendered;
    const isThisSlotMachinePage : boolean = (game?.phase === Phase.SLOT_MACHINE || isPageSlotMachineDemoRendered);
    const strengthCardWidth =  isBrowserWidthNecessary ? width * 0.1555 : "";

    const getStrengthCardsStyle = () => {
        if (isFullScreenOn) return showStrengthsOnFullScreen();
        if (isThisSlotMachinePage) return renderStrenghtCardTypeSlotmachine();
        if (!isThisSlotMachinePage) return renderStrenghtCardTypeGame();
    }
    
    const renderStrenghtCardTypeSlotmachine = () => {
        return (
            <div className="front_side__strenght" style={{ width: "100%", height: strengthCardWidth }} >
                
                <div className="strength_card_info_butotn_wrapper strength_card_info_button_wrapper_slotmachine_size" >
                    <InfoButton clickHandler={() => setDisplayInfo(!displayInfo)} cardType={cardData.type} />
                </div>

                <div className="strength_card_front_side_svg" > </div>
                <div className="card_content_wrapper center_horizontally_and_vertically" style={{height:'65%', marginTop: "5%", overflow: "hidden"}}>
                    {!displayInfo && <p className="front_side__strenght-title_slot_machine">{cardData.description}</p> }
                    { displayInfo && 
                    <div className="front_side__strenght-description_slot_machine">
                        {cardData.info}
                    </div> }
                </div>
            </div>
        );    
    }

    const renderStrenghtCardTypeGame = () => {
        return (
            <div className="front_side__strenght" style={{ width: "100%", height: strengthCardWidth }} >
                
                <div className={` strength_card_front_side_svg_game ${instructionTutorial === "leftSideOfTheScreen" && "white_box_shadow_for_strengths"} `} >
                    <div className="strength_card_info_butotn_wrapper strength_card_info_button_wrapper_size" >
                        <InfoButton clickHandler={() => setDisplayInfo(!displayInfo)} cardType={cardData.type} />
                    </div>
                    <div className="card_content_wrapper center_horizontally_and_vertically" style={{ height:'60%', overflow: "hidden"}}>
                        {!displayInfo && <p className="front_side__strenght-title_game" > {cardData.description} </p> }
                        { displayInfo && <div className="front_side__strenght-description_game" > {cardData.info} </div> }
                    </div>
                </div>
               
            </div>
        );    
    }

    const showStrengthsOnFullScreen = () => {
        return (
            <div className="strength_front_side_full_screen" >

                <div className="strength_front_side_full_screen_relative_wrapper">
                    <div className={`strength_front_side_full_screen_absolute_wrapper ${"transform_scale_strength_card_"+strengthCardIndex} `}>
                        <div className="strength_front_side_full_screen_svg_game" >
                            <div className="strength_card_info_butotn_wrapper strength_card_info_button_wrapper_size" >
                                <InfoButton clickHandler={() => setDisplayInfo(!displayInfo)} cardType={cardData.type} />
                            </div>
                            <div className="card_content_full_screen_wrapper center_horizontally_and_vertically" style={{ height:'70%', overflow: "hidden"}}>
                                {!displayInfo && <p className="strength_card_full_screen_title" > {cardData.description} </p> }
                                { displayInfo && 
                                <div className="strength_card_full_screen_description" >
                                    {cardData.info}
                                </div> }
                            </div>
                        </div>
                    </div>
                </div>
                
                
               
            </div>
        );    
    }

    return (
        <React.Fragment>
            {getStrengthCardsStyle()}
        </React.Fragment>
    );
}

export default StrengthCard;